import React from "react"
import { useSelector, useDispatch } from "react-redux"

import Images from "assets/images"
import { VIEW } from "const"
import { MtModule } from "server/models"
import { mtModulesRoute } from "client/parts/routes"
import { StoreType, addModal } from "client/store"
import {
    Logo,
    Link,
    DateFormatter,
    TableColumn,
} from "client/components"

const Columns = () => {
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "logo",
            header: lang.logo,
            centerAlign: true,
            formatter: (module: MtModule) => {
                const href = `${mtModulesRoute}/${VIEW}/${module.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        <Logo table logo={module.logo || Images.defaultLogo} />
                    </Link>
                )
            },
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "250px",
            formatter: (module: MtModule) => {
                const href = `${mtModulesRoute}/${VIEW}/${module.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        {module.shortName ? `${module.name} (${module.shortName})` : module.name}
                    </Link>
                )
            },
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (module: MtModule) => <DateFormatter date={module.createdAt} />,
        },
        {
            field: "status",
            header: lang.status,
            centerAlign: true,
            sortable: true,
            editAccess: () => true,
        },
    ]

    return columns
}
export default Columns
